<form [formGroup]="form">
    <div class="form-group">
        <label class="form-label" for="tag">{{'INSERT_TAG' | translate}}</label>
        <input type="text" class="form-control" [placeholder]="'TYPE_TO_SEARCH' | translate"
            formControlName="tag"
            [isAnimated]="true"
            [dropup]="true"
            [typeahead]="tags$"
            [typeaheadAsync]="true"
            [typeaheadMinLength]="0"
            (typeaheadOnSelect)="onTagSelected($event)"
            title="{{'INSERT_TAG' | translate}}">
    </div>
</form>

<div class="d-flex flex-wrap gap-2 mt-3">
    <button *ngFor="let tag of selectedTags" type="button" class="btn-sm-gs-full-secondary d-flex align-items-center gap-1">
        {{tag.name}}
        <button type="button" class="btn-close pull-right" aria-label="Close" (click)="removeTag(tag.id)"></button>
    </button>
</div>